/**
 * Worker utility functions
 * Shared logic for worker-related operations across components and transformers
 */

/**
 * Determines if we're in a change request context
 * A change request exists when there are previous worker IDs to compare against
 */
export function isChangeRequest(previousWorkerIds?: number[] | null): boolean {
  return Boolean(previousWorkerIds?.length)
}

/**
 * Determines if a worker is new in a change request context
 * A worker is considered "new" only if:
 * 1. We're in a change request (have previous workers to compare against)
 * 2. The worker didn't exist in the previous version
 */
export function isWorkerNew(workerUserProfileId: number, previousWorkerIds?: number[] | null): boolean {
  const inChangeRequest = isChangeRequest(previousWorkerIds)
  return inChangeRequest && !previousWorkerIds!.includes(workerUserProfileId)
}

/**
 * Determines if a worker existed in the previous version
 */
export function isWorkerExisting(workerUserProfileId: number, previousWorkerIds?: number[] | null): boolean {
  return Boolean(
    previousWorkerIds && 
    previousWorkerIds.length > 0 && 
    previousWorkerIds.includes(workerUserProfileId)
  )
} 